export default "__VITE_ASSET__Fjy2Bjp8__"